import styled from 'styled-components';
import { AppBar, Toolbar, Button } from '@material-ui/core';
import { rgba } from 'polished';

// CONSTANTS
import { BLACK } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const FooterAppBar = styled(AppBar)`
  top: auto;
  bottom: 0;

  background-color: ${p => p.theme.palette.background.default};

  .right-side {
    margin-left: auto;
  }

  &.app-bar--shadow {
    box-shadow: 0 1px 20px ${rgba(BLACK, 0.06)};
  }

  &.only-buttons {
    position: static;
    box-shadow: none;
    z-index: 1;
  }

  &.fmb,
  &.channels,
  &.services,
  &.superbundle-results {
    .next-button,
    .previous-button {
      max-height: 40px;
      padding: 1.3rem;
    }

    .previous-button .MuiSvgIcon-root {
      color: inherit;
      font-size: 2.4rem;
      margin: -5px 0;
      transform: rotate(180deg);
    }

    ${breakpoints.down('xs')} {
      padding-bottom: 12px;

      box-shadow: 0 4px 16px ${rgba(BLACK, 0.25)};

      .next-button {
        width: 100%;
      }

      .channel-list__link {
        padding-bottom: 10px;
      }
    }
  }
`;

export const StyledToolbar = styled(Toolbar)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  padding-top: 8px;
  padding-bottom: 8px;

  ${breakpoints.down('sm')} {
    height: auto;
    min-height: 60px;
  }

  ${breakpoints.up(600)} {
    &.MuiToolbar-gutters {
      padding-left: 30px;
      padding-right: ${p => (p.type === 'results' || p.type === 'csr-results' ? 0 : '30px')};
    }
  }
`;

export const StyledButton = styled(Button)`
  width: 130px;
`;
